module.exports = __webpack_public_path__ + "static/media/6.859f7860.png";